import { Box } from '@factorialco/deprecated-design-system'
import { Rocket } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import DiscoverMoreSection from 'modules/expenses/pages/settings/Content/DiscoverMore'
import SectionInfo from 'modules/expenses/pages/settings/ExpensePolicy/Components/_SectionInfo'

interface Props {
  hasReportOnBehalfFeature: boolean
}

const DiscoverMore = ({ hasReportOnBehalfFeature }: Props) => {
  return (
    <Box flexDirection="column" gap="s24" paddingX="s24" flexGrow>
      <SectionInfo
        icon={Rocket}
        title={i18n.t('expenses_v2.settings.discover_more_features.title')}
        description={i18n.t('expenses_v2.settings.discover_more_features.description')}
      />

      <DiscoverMoreSection hasReportOnBehalfFeature={hasReportOnBehalfFeature} hideTitle />
    </Box>
  )
}

export default DiscoverMore
